// The bundled version includes popper.js.
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

String.prototype.paddingLeft = function(paddingValue) {
	return String(paddingValue + this).slice(-paddingValue.length);
};
